import { ContractSummaryRecord } from "models/view-models/contracts/contract-summary-record";
import { NumberUtils } from "utilities/number-utils";
import { OrganizationOLLContractSummariesService } from "utilities/services/organizations/organization-oll-contract-summaries-service";
import { ResultErrorRecord } from "andculturecode-javascript-core";
import { ToastManager } from "utilities/toast/toast-manager";
import { useEffect, useState } from "react";
import { t } from "utilities/localization/t";

interface useOrganizationOLLContractSummariesHook {
    contractSummaries: ContractSummaryRecord[];
    isLoading: boolean;
    errors?: ResultErrorRecord[];
}

interface useOrganizationOLLContractSummariesHookOptions {
    includeWithdrawn?: boolean;
    organizationId?: number | string;
}

export function useOrganizationOLLContractSummaries(
    props: useOrganizationOLLContractSummariesHookOptions
): useOrganizationOLLContractSummariesHook {
    const [isLoading, setIsLoading] = useState(true);
    const [contractSummaries, setContractSummaries] = useState<ContractSummaryRecord[]>([]);
    const [errors, setErrors] = useState<ResultErrorRecord[]>();
    const { list: listContractSummariesAPI } = OrganizationOLLContractSummariesService.useList();
    const organizationId = NumberUtils.parseInt(props.organizationId) ?? 0;

    useEffect(() => {
        if (isNaN(organizationId) || organizationId < 1) {
            return;
        }
        try {
            (async function getContractSummaries() {
                const { result, resultObjects } = await listContractSummariesAPI(
                    { organizationId: organizationId },
                    { includeWithdrawn: props.includeWithdrawn }
                );

                setIsLoading(false);

                if (result?.hasErrors()) {
                    const { errors } = result ?? {};
                    setErrors(errors ?? []);
                    return;
                }

                setContractSummaries(resultObjects);
            })();
        } catch {
            ToastManager.error(t("thereWasAProblemReturningContractSummaries"));
        }
    }, [organizationId, listContractSummariesAPI, props.includeWithdrawn]);

    return {
        errors,
        isLoading,
        contractSummaries,
    };
}
